import { categoryIcon, type ExpenseCategory } from "@qota/shared";
import { isIconName, type IconName } from "@qota/ui";

/**
 * L'icona di una categoria, come nome valido per `<Icon>`.
 *
 * `@qota/shared` non può importare `@qota/ui` — sarebbe una dipendenza
 * circolare — quindi nomina le icone per stringa e qui va richiuso il cerchio.
 * Un test copre l'intero registro, ma il ripiego resta: un'icona mancante deve
 * disegnare uno scontrino, non far esplodere la lista delle spese.
 */
export function iconFor(category: ExpenseCategory): IconName {
  const name = categoryIcon(category);
  return isIconName(name) ? name : "receipt";
}
